<div class="npi-number-step">
  <div class="dialog-header">
    <div *ngIf="location === PharmacyLocationEnum.Setup" class="header">
      Welcome {{(userData$ | async)?.firstName}}!
    </div>

    <div *ngIf="location === PharmacyLocationEnum.Settings" class="header">
      Add a pharmacy
    </div>

    <div *ngIf="location === PharmacyLocationEnum.Setup" class="description">
      We’ll have you up and running in no time. <br>
      To make it easy, let’s gather some details about your pharmacy.
    </div>

    <div *ngIf="location === PharmacyLocationEnum.Settings" class="description">
      Let’s gather details about your pharmacy.
    </div>
  </div>

  <form class="dialog-body" [formGroup]="npiForm">
    <div class="form-fields">
      <app-input [label]="'Enter your pharmacy’s NPI number'"
                 formControlName="npiNumber"
                 [type]="'number'"
                 (keyupEnter)="getPharmacyByNPI()"
                 [maxLength]="NPIMaxLength"
                 [autofocus]="true"
                 #npiNumberInput
      ></app-input>
      <app-checkbox id="termsConditions" class="block pt-5"
        formControlName="termsConditions"
        #termsConditionsCheckbox
        (checkBoxToggled)="termAndConditionsCheckBoxToggled($event)"
        (keydownTab)="focusBaaCheckbox()">
        <span class="checkbox-text">
          I agree with the terms and conditions of the <a href="" (click)="onEulaClick($event)" class="link">EULA</a>
        </span>
      </app-checkbox>
      
      <div class="divider"></div>
      <div>
        <div class="label default !mb-2">You must enter into a BAA agreement with C2Keep to use the system:</div>
        <app-options-list formControlName="baa" [optionsList]="baaOptionsList"
        (linkClicked)="onBaaClick()"></app-options-list>
      </div>
    </div>

    <div class="controls">
      <app-button customClasses="w-full"
                  text="Continue"
                  class="next-btn"
                  [loading]="loading$ | async"
                  [disabled]="loading$ | async"
                  (keydownTab)="focusNpi()"
                  (clicked)="getPharmacyByNPI()"
                  #submit
      >
      </app-button>

      <app-button *ngIf="location === PharmacyLocationEnum.Settings"
                  customClasses="w-full"
                  [text]="'Cancel'"
                  subStyle="transparent"
                  class="sign-out-btn"
                  [disabled]="(loading$ | async) === true"
                  (clicked)="closeNpi()"
      >
      </app-button>
    </div>
  </form>
</div>
